export default "__VITE_ASSET__Ccz0fylO__"